import React from "react";
import { FiMoreVertical, FiDownload, FiUser, FiCheck } from "react-icons/fi";
import { Dropdown } from "../../../tailadmin/components/ui/dropdown/Dropdown";
import { DropdownItem } from "../../../tailadmin/components/ui/dropdown/DropdownItem";

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
  onToggle: () => void;
  isStudent: boolean;
  onViewProfile: () => void;
  onExportConversation: () => void;
  isExporting: boolean;
  exportSuccess: boolean;
}

export const Menu: React.FC<MenuProps> = ({
  isOpen,
  onClose,
  onToggle,
  isStudent,
  onViewProfile,
  onExportConversation,
  isExporting,
  exportSuccess,
}) => (
  <div className="relative flex-shrink-0">
    <button
      onClick={onToggle}
      className="dropdown-toggle p-2.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-200 active:scale-95"
      aria-label="Menu de opções"
      aria-expanded={isOpen}
    >
      <FiMoreVertical size={20} className="text-gray-600 dark:text-gray-300" />
    </button>

    <Dropdown isOpen={isOpen} onClose={onClose} className="w-52 py-1">
      {isStudent && (
        <DropdownItem
          onClick={onViewProfile}
          className="flex items-center gap-3 px-4 py-2.5 hover:bg-purple-50 dark:hover:bg-purple-900/20 text-gray-700 dark:text-gray-300 transition-colors"
        >
          <FiUser size={18} className="text-purple-600 dark:text-purple-400" />
          <span className="font-medium">Ver perfil</span>
        </DropdownItem>
      )}
      <DropdownItem
        onClick={onExportConversation}
        className="flex items-center gap-3 px-4 py-2.5 hover:bg-purple-50 dark:hover:bg-purple-900/20 text-gray-700 dark:text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {exportSuccess ? (
          <>
            <FiCheck size={18} className="text-green-600 dark:text-green-400" />
            <span className="font-medium text-green-600 dark:text-green-400">
              Exportado!
            </span>
          </>
        ) : (
          <>
            <FiDownload
              size={18}
              className="text-purple-600 dark:text-purple-400"
            />
            <span className="font-medium">
              {isExporting ? "Exportando..." : "Exportar conversa"}
            </span>
          </>
        )}
      </DropdownItem>
    </Dropdown>
  </div>
);
